import { useTranslation } from 'react-i18next';

// Hardcoded trust signals — update manually when the Play listing changes.
const stats = [
  { value: '4.8M+', labelKey: 'SocialProof.downloads' },
  { value: '13.5K', labelKey: 'SocialProof.ratings' },
  { value: '4.5★', labelKey: 'SocialProof.rating' },
];

// Real Google Play reviews. Kept in English across all locales (a genuine
// testimonial should not be machine-translated).
const reviews = [
  {
    quote: 'This is very good apps and highly recommended for students. It helps circuit activities.',
    name: 'Roy',
    stars: 5,
  },
  {
    quote: 'Good for beginners, close to real life simulation. Very easy to use and learn on your own.',
    name: 'Kazim',
    stars: 5,
  },
  {
    quote: "If you're designing and building circuits for fun or professionally on the job Proto can help you achieve success. It's great having this app to virtually build my circuits in for testing, and an added bonus is your schematic is already made for your device — just print it off.",
    name: 'Reverend',
    stars: 5,
  },
];

const sectionStyle = { padding: '80px 0' };

const statValueStyle = {
  fontSize: 'clamp(26px, 7vw, 48px)',
  fontWeight: 800,
  color: '#ffd451',
  fontFamily: 'Raleway, sans-serif',
  lineHeight: 1.1,
  margin: 0,
};

const statLabelStyle = {
  fontSize: 'clamp(11px, 3vw, 14px)',
  color: '#90a4ae',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  marginTop: '8px',
};

const cardStyle = {
  backgroundColor: 'rgba(0,0,0,0.25)',
  borderRadius: '12px',
  padding: '30px',
  border: '1px solid rgba(255,212,81,0.15)',
  height: '100%',
};

const quoteStyle = {
  fontSize: '15px',
  color: '#cfd8dc',
  lineHeight: '1.7',
  fontStyle: 'italic',
  margin: '0 0 16px',
};

const nameStyle = {
  fontSize: '14px',
  fontWeight: 700,
  color: '#ffd451',
  letterSpacing: '0.5px',
  margin: 0,
};

const starsStyle = { color: '#ffd451', fontSize: '16px', marginBottom: '12px', letterSpacing: '2px' };

const titleWrapStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'clamp(12px, 3vw, 28px)',
};

const laurelStyle = {
  height: 'clamp(72px, 16vw, 140px)',
  width: 'auto',
  flexShrink: 0,
};

export const SocialProof = (props) => {
  const { t } = useTranslation();

  return (
    <section id='social-proof' className='text-center' aria-label='Social proof' style={sectionStyle}>
      <div className='container'>
        <div className='section-title' style={titleWrapStyle}>
          <img src='/img/laurel.png' alt='' aria-hidden='true' style={laurelStyle} />
          <h2 style={{ margin: 0 }}>{t('SocialProof.title')}</h2>
          <img
            src='/img/laurel.png'
            alt=''
            aria-hidden='true'
            style={{ ...laurelStyle, transform: 'scaleX(-1)' }}
          />
        </div>

        <div className='row' style={{ marginBottom: '50px' }}>
          {stats.map((stat) => (
            <div key={stat.labelKey} className='col-xs-4'>
              <p style={statValueStyle}>{stat.value}</p>
              <p style={statLabelStyle}>{t(stat.labelKey)}</p>
            </div>
          ))}
        </div>

        <div className='row'>
          {reviews.map((review) => (
            <div key={review.name} className='col-md-4' style={{ marginBottom: '20px' }}>
              <div style={cardStyle}>
                <div style={starsStyle} aria-label={`${review.stars} out of 5 stars`}>
                  {'★'.repeat(review.stars)}
                </div>
                <p style={quoteStyle}>&ldquo;{review.quote}&rdquo;</p>
                <p style={nameStyle}>{review.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
